import commonErrMsg from './commonErrMsg'

/**
 * 用来规范cgi报错时的报错提示（双行提示）
 * @param {Object} res cgi返回的结果
 * @return {Object} tips
 *  tips.msg 主要提示信息
 *  tips.info 次要提示信息
 */
export default function (res) {
  if (res.err_code) {
    return {
      msg: commonErrMsg,
      info: '错误码：' + res.err_code
    }
  }

  if (!res.msg) {
    return {
      msg: commonErrMsg,
      info: res.ret ? '错误码：' + res.ret : ''
    }
  }

  return {
    msg: res.msg,
    info: ''
  }
}